/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BrickData,
  ProtectedBricksPageable,
} from '../models/index';
import {
    BrickDataFromJSON,
    BrickDataToJSON,
    ProtectedBricksPageableFromJSON,
    ProtectedBricksPageableToJSON,
} from '../models/index';

export interface GetProtectedBrickByPartNumberRequest {
    partNumber: string;
}

export interface GetProtectedBricksRequest {
    page?: number;
    limit?: number;
    search?: string;
    status?: GetProtectedBricksStatusEnum;
}

/**
 * 
 */
export class ProtectedBricksApi extends runtime.BaseAPI {

    /**
     * Gibt Schutz-Informationen für eine spezifische Teilenummer zurück
     * Schutz-Informationen für ein Teil
     */
    async getProtectedBrickByPartNumberRaw(requestParameters: GetProtectedBrickByPartNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BrickData>> {
        if (requestParameters.partNumber === null || requestParameters.partNumber === undefined) {
            throw new runtime.RequiredError('partNumber','Required parameter requestParameters.partNumber was null or undefined when calling getProtectedBrickByPartNumber.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected-bricks/{partNumber}`.replace(`{${"partNumber"}}`, encodeURIComponent(String(requestParameters.partNumber))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BrickDataFromJSON(jsonValue));
    }

    /**
     * Gibt Schutz-Informationen für eine spezifische Teilenummer zurück
     * Schutz-Informationen für ein Teil
     */
    async getProtectedBrickByPartNumber(requestParameters: GetProtectedBrickByPartNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BrickData> {
        const response = await this.getProtectedBrickByPartNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt die Datenbank aller geschützten Steine paginiert zurück
     * Datenbank der geschützten Steine (paginiert)
     */
    async getProtectedBricksRaw(requestParameters: GetProtectedBricksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProtectedBricksPageable>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected-bricks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProtectedBricksPageableFromJSON(jsonValue));
    }

    /**
     * Gibt die Datenbank aller geschützten Steine paginiert zurück
     * Datenbank der geschützten Steine (paginiert)
     */
    async getProtectedBricks(requestParameters: GetProtectedBricksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProtectedBricksPageable> {
        const response = await this.getProtectedBricksRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetProtectedBricksStatusEnum = {
    Active: 'active',
    Expired: 'expired',
    All: 'all',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type GetProtectedBricksStatusEnum = typeof GetProtectedBricksStatusEnum[keyof typeof GetProtectedBricksStatusEnum];
